import {StylesParamsType} from '../../types/createStylesParams'
import {
  buttonDefaultStylesParams,
  buttonHoverStylesParams,
  ButtonDefaultStylesParams,
  ButtonHoverStylesParams,
} from '../../components-shared/Settings/Button/stylesParams'
import {
  linkStylesParams,
  LinkStylesParams,
} from '../../components-shared/Settings/Link/stylesParams'
import {
  formBoxStylesParams,
  formLineStylesParams,
  FormBoxStylesParams,
  FormLineStylesParams,
} from '../../components-shared/Settings/FormDesign/stylesParams'

import {layoutStylesParams, LayoutStylesParams} from './Settings/Tabs/Layout/stylesParams'
import {generalStylesParams, GeneralStylesParams} from './Settings/Tabs/Design/General/stylesParams'
import {
  timeSlotsDefaultStylesParams,
  timeSlotsSelectedStylesParams,
  timeSlotsClosedStylesParams,
  TimeSlotsDefaultStylesParams,
  TimeSlotsSelectedStylesParams,
  TimeSlotsClosedStylesParams,
} from './Settings/Tabs/Design/TimeSlots/stylesParams'

export type StylesParams = LayoutStylesParams &
  GeneralStylesParams &
  FormBoxStylesParams &
  FormLineStylesParams &
  TimeSlotsDefaultStylesParams &
  TimeSlotsSelectedStylesParams &
  TimeSlotsClosedStylesParams &
  ButtonDefaultStylesParams &
  ButtonHoverStylesParams &
  LinkStylesParams

export const stylesParams: StylesParamsType<StylesParams> = {
  ...layoutStylesParams,
  ...generalStylesParams,
  ...formBoxStylesParams,
  ...formLineStylesParams,
  ...timeSlotsDefaultStylesParams,
  ...timeSlotsSelectedStylesParams,
  ...timeSlotsClosedStylesParams,
  ...buttonDefaultStylesParams,
  ...buttonHoverStylesParams,
  ...linkStylesParams,
}

export default stylesParams
